import React from "react";



const Superficies = (props) => {

  const superficieHandleOne = (minPrice, maxPrice, interval) => {
    const arrayPrices = [];
    for (let i = minPrice; i <= maxPrice; i = i + interval) {
      arrayPrices.push(i);
    }
    return superficieHandleTwo(arrayPrices);
  }
  const superficieHandleTwo = (arrayPrices) => {
    return (
      arrayPrices.map((item, index) =>
        <option key={index} value={item}>{`${item} m2`}</option>
      )
    )
  }

  return (
    <>
      <option value='indiferente'>Indiferente</option>
      {
        props.fotoCasaForm.tipoInmueble === 'vivienda' ?
          <>
            {superficieHandleOne(60, 300, 20)}
          </>
          : props.fotoCasaForm.tipoInmueble === 'local-nave' ?
          <>
            {superficieHandleOne(50, 800, 50)}
          </>
          : props.fotoCasaForm.tipoInmueble === 'garaje' ?
          <>
            {superficieHandleOne(8, 40, 8)}
          </>
          : props.fotoCasaForm.tipoInmueble === 'oficina' ?
          <>
            {superficieHandleOne(50, 800, 50)}
          </>
          : props.fotoCasaForm.tipoInmueble === 'trastero' ?
          <>
            {superficieHandleOne(5, 25, 5)}
          </>
          : props.fotoCasaForm.tipoInmueble === 'terreno' ?
          <>
            {superficieHandleOne(200, 3000, 200)}
          </>
          :
          <>
            {superficieHandleTwo([200, 400, 600, 900, 1200, 1500, 2000, 3000, 5000, 7500, 10000])}
          </>
      }
    </>)
}

export default Superficies;